import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { ApiClient } from '@sfs-projects/sfs-fc-api-sdk';
import * as _ from 'lodash';
import env from "@/utils/env";

const perPage = env.VUE_APP_PER_PAGE;

interface InvoicesResponse {
  Paginate: {
    currentPage: number;
    perPage: number;
    totalRow: number;
  };
  invoiceList: Array<any>;
  creditorOptionList?: Array<any>;
  debtorOptionList?: Array<any>;
  invoiceTypeList?: Array<any>;
}

@Module({ namespaced: true })
class InvoicesModule extends VuexModule {
  public invoiceList: Array<any> = [];
  public creditorOptionList: Array<any> = [];
  public debtorOptionList: Array<any> = [];
  public invoiceTypeList: Array<any> = [];
  public lastKey: any;
  @Mutation
  public setLastKey(lastkey: any): void {
    this.lastKey = lastkey;
  }
  @Mutation
  public setInvoiceList(list: Array<any>): void {
    this.invoiceList = list;
  }

  @Mutation
  public setCreditorOptionList(list: Array<any>): void {
    this.creditorOptionList = list;
  }

  @Mutation
  public setDebtorOptionList(list: Array<any>): void {
    this.debtorOptionList = list;
  }

  @Mutation
  public addInvoiceList(list: Array<any>): void {
    list.forEach(item => {
      const index = this.invoiceList.findIndex(x => x.InvoiceNr == item.InvoiceNr)
      if (index === -1) {
        this.invoiceList.push(item);
      }
    })
  }

  @Mutation
  public addCreditorOptionList(list: Array<any>): void {
    list.forEach(item => {
      const index = this.creditorOptionList.findIndex(x => x == item)
      if (index === -1) {
        this.creditorOptionList.push(item);
      }
    })
  }

  @Mutation
  public addDebtorOptionList(list: Array<any>): void {
    list.forEach(item => {
      const index = this.debtorOptionList.findIndex(x => x == item)
      if (index === -1) {
        this.debtorOptionList.push(item);
      }
    })
  }

  @Mutation
  public addInvoiceTypeList(list: Array<any>): void {
    list.forEach(item => {
      const index = this.invoiceTypeList.findIndex(x => x == item)
      if (index === -1) {
        this.invoiceTypeList.push(item);
      }
    })
  }

  @Mutation
  public setInvoiceTypeList(list: Array<any>): void {
    this.invoiceTypeList = list;
  }

  /**
   * Search invoice (page 1)
   * @param params 
   */
  @Action
  public async retrieveInvoices(params: any): Promise<InvoicesResponse> {
    return new Promise((resolve, reject) => {
      //@TODO: check if filter data already have in state
      // If state have data then return that data
      ApiClient.post(params.url, params.filterData).then((response: any) => {
        if (response.data.length > 0 && params.Sort == undefined) {
          // @TODO: Refactor sort by CreatAt, currently use lodash
          response.data = _.orderBy(response.data, ['CreateAt'], ['desc'])
        }
        const invoiceList = response.data;
        const creditorList = _.uniq(_.map(invoiceList, 'CreditorName'));
        const debtorList = _.uniq(_.map(invoiceList, 'DebtorName'));
        const invoiceTypeList = _.uniq(_.map(invoiceList, 'InvoiceType'));
        // Keep data AND lastkey in state
        this.context.commit('setInvoiceList', invoiceList);
        this.context.commit('setLastKey', response.LastKey);
        // If search result not null then update list options, if nut, re-set option list
        if (this.creditorOptionList.length == 0 || response.length == 0) {
          this.context.commit('setCreditorOptionList', creditorList);
        } else {
          this.context.commit('addCreditorOptionList', creditorList);
        }

        // If search result not null then update list options, if nut, re-set option list
        if (this.debtorOptionList.length == 0 || response.length == 0) {
          this.context.commit('setDebtorOptionList', debtorList);
        } else {
          this.context.commit('addDebtorOptionList', debtorList);
        }

        // If search result not null then update list options, if nut, re-set option list
        if (this.invoiceTypeList.length == 0 || response.length == 0) {
          this.context.commit('setInvoiceTypeList', invoiceTypeList);
        } else {
          this.context.commit('addInvoiceTypeList', invoiceTypeList);
        }
        const result = {
          Paginate: {
            currentPage: 1,
            perPage: perPage,
            totalRow: this.invoiceList.length
          },
          invoiceList: invoiceList.slice(0, perPage), // Get first perpage item 
          creditorOptionList: creditorList,
          debtorOptionList: debtorList,
        }
        resolve(result);
      }, error => {
        reject(error);
      });
    })
  }

  /**
   * Get item per paginate
   * @param url 
   * @param params 
   */
  @Action
  public async getItemPerPage(params: any): Promise<any> {
    params.page = params.page ?? 1; //set page default = 1 if page not send
    return new Promise((resolve, reject) => {
      const totalpage = this.invoiceList.length / perPage;
      if (params.page >= totalpage && this.lastKey) {
        params.filter.filterData.LastKey = this.lastKey;
        ApiClient.post(params.filter.url, params.filter.filterData).then((response: any) => {
          if (response.data.length > 0 && params.Sort == undefined) {
            // @TODO: refactor sort by CreatAt, currently use lodash
            response.data = _.orderBy(response.data, ['CreateAt'], ['desc'])
          }
          const invoiceList = response.data;
          const creditorList = _.uniq(_.map(invoiceList, 'CreditorName'));
          const debtorList = _.uniq(_.map(invoiceList, 'DebtorName'));
          //keep data AND lastkey in state
          this.context.commit('addInvoiceList', invoiceList);
          this.context.commit('setLastKey', response.LastKey);
          this.context.commit('addCreditorOptionList', creditorList);
          this.context.commit('addDebtorOptionList', debtorList);
          const result = {
            Paginate: {
              currentPage: params.page,
              perPage: perPage,
              totalRow: this.invoiceList.length
            },
            invoiceList: this.invoiceList.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage),
            creditorOptionList: creditorList,
            debtorOptionList: debtorList
          }
          resolve(result);
        }, error => {
          reject(error);
        });
      } else {
        const result = {
          invoiceList: this.invoiceList.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
        }
        resolve(result);
      }
    })
  }

  @Action
  public async getTotalAmount(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.post(params.url, params.data).then((response: any) => {
        resolve(response);
      }, error => {
        reject(error);
      });
    })
  }

  @Action
  public async updateInvoice(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.put(params.url, params.data).then((response: any) => {
        resolve(response);
      }, error => {
        reject(error);
      });
    })
  }

}
export default InvoicesModule